import { PopoverTrigger, PopoverTriggerProps } from "@datamole/wds-component-popover";
import { forwardRef } from "react";

type Props = PopoverTriggerProps;

const Trigger = forwardRef<HTMLButtonElement, Props>((props, ref) => {
    return <PopoverTrigger {...props} ref={ref} />;
});

Trigger.displayName = "Menu.Trigger";

export { Trigger as MenuTrigger };
export type { Props as MenuTriggerProps };
